/**
 * Convert mobile BibleLocation to web format
 */
export function mobileToWebLocation(mobile) {
    return {
        testamentIndex: mobile.testament - 1,
        bookIndex: mobile.book - 1,
        chapterIndex: mobile.chapter,
        verseIndex: mobile.verse,
        ...(mobile.word !== undefined && { wordIndex: mobile.word }),
    };
}
/**
 * Convert web BibleLocation to mobile format
 */
export function webToMobileLocation(web) {
    return {
        testament: web.testamentIndex + 1,
        book: web.bookIndex + 1,
        chapter: web.chapterIndex,
        verse: web.verseIndex,
        ...(web.wordIndex !== undefined && { word: web.wordIndex }),
    };
}
/**
 * Check if two BibleLocations are equal (same verse)
 */
export function isLocationEqual(a, b) {
    return (a.testamentIndex === b.testamentIndex &&
        a.bookIndex === b.bookIndex &&
        a.chapterIndex === b.chapterIndex &&
        a.verseIndex === b.verseIndex);
}
/**
 * Check if a location is within a chapter (for filtering notes/bookmarks)
 */
export function isLocationInChapter(location, chapterLocation) {
    return (location.testamentIndex === chapterLocation.testamentIndex &&
        location.bookIndex === chapterLocation.bookIndex &&
        location.chapterIndex === chapterLocation.chapterIndex);
}
//# sourceMappingURL=converters.js.map